import { useEffect, useState,useCallback } from "react";
import axios from "axios";
import { FiFileText, FiFilter, FiDownload } from "react-icons/fi";

export default function AdvancedReports() {
    const [loading, setLoading] = useState(true);
    const [reports, setReports] = useState([]);
    const [filters, setFilters] = useState({
        status: 'all',
        category: 'all',
        dateRange: 'all'
    });


    const fetchReports = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get("/api/v1/app/user-reports", {
        params: filters,
      });
      if (response.data.success) {
        setReports(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    } finally {
      setLoading(false);
    }
  }, [filters]); // depends on filters

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

    const exportReports = () => {
        // Export functionality would go here
        alert('Export functionality coming soon!');
    };

    if (loading) {
        return (
            <div className="p-6">
                <div className="flex justify-center items-center h-40">
                    <div className="w-8 h-8 border-4 border-pink-200 border-t-pink-600 rounded-full animate-spin" />
                </div>
            </div>
        );
    }

    return (
        <div className="p-6 space-y-6">
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
                    <FiFileText className="text-pink-600" />
                    Advanced Reports
                </h1>
                <button
                    onClick={exportReports}
                    className="flex items-center gap-2 px-4 py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors"
                >
                    <FiDownload />
                    <span>Export</span>
                </button>
            </div>

            {/* Filters */}
            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center gap-3 mb-4">
                    <FiFilter className="text-gray-600" />
                    <h2 className="text-lg font-semibold text-gray-800">Filters</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                        <select
                            value={filters.status}
                            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                        >
                            <option value="all">All</option>
                            <option value="PENDING">Pending</option>
                            <option value="RESOLVED">Resolved</option>
                            <option value="DISMISSED">Dismissed</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
                        <select
                            value={filters.category}
                            onChange={(e) => setFilters({ ...filters, category: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                        >
                            <option value="all">All</option>
                            <option value="SPAM">Spam</option>
                            <option value="HARASSMENT">Harassment</option>
                            <option value="INAPPROPRIATE_CONTENT">Inappropriate Content</option>
                            <option value="FRAUD">Fraud</option>
                            <option value="FAKE_PROFILE">Fake Profile</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Date Range</label>
                        <select
                            value={filters.dateRange}
                            onChange={(e) => setFilters({ ...filters, dateRange: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                        >
                            <option value="all">All Time</option>
                            <option value="today">Today</option>
                            <option value="week">This Week</option>
                            <option value="month">This Month</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Reports Table */}
            <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-bold mb-4 text-gray-800">Reports</h2>
                {reports.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="text-left text-sm text-gray-500 border-b">
                                    <th className="pb-3">ID</th>
                                    <th className="pb-3">Reporter</th>
                                    <th className="pb-3">Reported</th>
                                    <th className="pb-3">Category</th>
                                    <th className="pb-3">Status</th>
                                    <th className="pb-3">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reports.map((report) => (
                                    <tr key={report.id} className="text-sm border-b hover:bg-gray-50 transition-colors">
                                        <td className="py-3 text-gray-800">{report.id?.slice(-8)}</td>
                                        <td className="py-3 text-gray-600">{report.reporter?.name || 'N/A'}</td>
                                        <td className="py-3 text-gray-600">{report.reported?.name || 'N/A'}</td>
                                        <td className="py-3">
                                            <span className="px-2 py-1 rounded text-xs bg-gray-100 text-gray-800">
                                                {report.category || 'N/A'}
                                            </span>
                                        </td>
                                        <td className="py-3">
                                            <span className={`px-2 py-1 rounded text-xs font-medium ${
                                                report.status === 'RESOLVED' ? 'bg-green-100 text-green-800' :
                                                report.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                                                'bg-gray-100 text-gray-800'
                                            }`}>
                                                {report.status || 'N/A'}
                                            </span>
                                        </td>
                                        <td className="py-3 text-gray-600">
                                            {report.createdAt ? new Date(report.createdAt).toLocaleDateString() : 'N/A'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-8 text-gray-400">No reports found</div>
                )}
            </div>
        </div>
    );
}

